import React from 'react'
import PlaceholderPage from '../../components/shared/PlaceholderPage'
import { Target } from 'lucide-react'

const features = [
  { name: 'Lead Scoring', description: 'Automatic scoring based on engagement' },
  { name: 'Pipeline Stages', description: 'Track leads through your sales pipeline' },
  { name: 'Activity Tracking', description: 'Log calls, emails, and meetings' },
  { name: 'Conversion Analytics', description: 'Measure lead-to-customer conversion' },
]

export default function LeadsView() {
  return (
    <PlaceholderPage
      title="Leads"
      description="Track and manage sales leads"
      icon={Target}
      features={features}
      accentColor="amber"
    />
  )
}
